// src/components/pages/admin-dash/AdminSubscriptionRetentionReport.jsx
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/AxiosInstance";
import AdminTable from "./AdminTable";

/**
 * Admin report — per-plan active/canceled counts, renewals, and average
 * time-to-cancel (GET /admin/reports/subscription-retention). Roadmap item 3.7.
 */
const fmtDays = (n) => (typeof n === "number" ? `${n.toFixed(0)}d` : "—");

export default function AdminSubscriptionRetentionReport() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await axiosInstance.get("/admin/reports/subscription-retention");
        setRows(res.data || []);
      } catch {
        setError("Failed to load subscription retention report.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const columns = [
    { key: "plan", label: "Plan", sort: true, value: (r) => r.plan || "" },
    { key: "activeCount", label: "Active", sort: true, align: "right",
      render: (r) => <span className="tabular-nums font-medium" style={{ color: "var(--gold)" }}>{r.activeCount}</span> },
    { key: "canceledCount", label: "Canceled", sort: true, align: "right",
      render: (r) => <span className="tabular-nums">{r.canceledCount}</span> },
    { key: "renewalCount", label: "Renewals", sort: true, align: "right",
      render: (r) => <span className="tabular-nums">{r.renewalCount}</span> },
    { key: "averageLifetimeDays", label: "Avg. time to cancel", sort: true, align: "right",
      render: (r) => <span className="tabular-nums">{fmtDays(r.averageLifetimeDays)}</span> },
  ];

  return (
    <div className="space-y-4">
      <header>
        <h1 className="font-semibold mb-1" style={{ fontSize: 22, color: "var(--txt)" }}>
          Subscription retention
        </h1>
        <p className="text-[12px]" style={{ color: "var(--txt-2)" }}>
          Active vs. canceled subscriptions per plan, renewal counts, and how long a
          canceled subscription tends to last before it's dropped. Snapshot as of now
          (not a date-range report).
        </p>
      </header>

      {error && (
        <div
          className="rounded-xl px-4 py-3 text-[13px]"
          style={{ background: "var(--red-dim)", border: "1px solid var(--red-border)", color: "var(--red)" }}
        >
          {error}
        </div>
      )}

      <AdminTable
        columns={columns}
        rows={rows}
        loading={loading}
        emptyIcon="repeat"
        emptyMessage="No subscription data yet."
        defaultSort={{ key: "activeCount", dir: "desc" }}
      />
    </div>
  );
}
